/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query SenderIdReadUniqueQuery($senderIdId: ID!) {
  SenderIdReadUnique(senderIdId: $senderIdId) {
    id,
    senderId,
    message,
    status
  }
}
`
